import { dateReformatTo_mmm_dd_yyyy } from '@fuse/utils/dateOperations'
import React from 'react'
import NoResultView from '@fuse/components/NoResultView'

function Contract({ contractInfo }) {
  if(!contractInfo){
    return (
      <NoResultView moduleName={'Contract'}/>
    )
  }

  return (
    <div className="table_responsive grey_table_holder mb-36">
      <table>
        <thead>
          <tr>
            <th>Contract Name</th>
            <th>Contract Number</th>
            <th>Status</th>
            <th>Contract Type</th>
            <th>Service Provider Name</th>
            <th>Service Level Agreement</th>
            <th>Start Date</th>
            <th>End Date</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{contractInfo.contract_name}</td>
            <td>{contractInfo.entity_external_platform_id}</td>
            <td>
              <span
                className="cstm_badge_holder m-0"
                style={{
                  backgroundColor: `${contractInfo.contract_header_status.status_color.code}`,
                  color: 'black'
                }}
              >{contractInfo.contract_header_status.contract_status_name}</span>
            </td>
            <td>{contractInfo.contract_headers_type.display_name}</td>
            <td>{contractInfo.contract_service_provider.service_provider_name}</td>
            <td>{contractInfo.service_level_agreement.sla_name}</td>
            <td>{dateReformatTo_mmm_dd_yyyy(contractInfo.contract_start_date)}</td>
            <td>{dateReformatTo_mmm_dd_yyyy(contractInfo.contract_end_date)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default Contract